import Vue from 'vue';
import Router from 'vue-router';
import axios from 'axios';
import store from '@/store';
import contract from './contract';
import Login from '@/views/Login.vue';
import _ from 'lodash';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

import util from '@/libs/util'

import {getMenuList} from './custommenu';
// 路由数据
import routes from './routes'


import VerifyPhoneNumber from '@/views/VerifyPhoneNumber.vue';
import menuAside from "@/menu/aside";

const Hello = () => import('@/views/Home.vue');


// @ts-ignore
const help = () => import('@/components/account/help.vue');


/*-----------------------------------*/
Vue.use(Router);

const router = new Router({
    routes
    // routes: [
    //   ...contract,
    //   ...accounts,
    //   ...manageCenter,
    //   ...booking,
    //   ...proof,
    //   ...orders, /*买家订单详细信息*/
    //   ...template, //模板都扔这里
    //   // {
    //   //   path: '/login',
    //   //   name: 'login',
    //   //   component: Login,
    //   // },
    //   {
    //     path: '/help',
    //     name: 'help',
    //     component: help,
    //   },
    //
    //   {
    //     path: '/home',
    //     name: 'Hello',
    //     component: Hello,
    //   },
    // ],
});
const current_permissions: any[] = [];
const permissions: any[] = [];//总权限目录
function checkPermitPass(to,next){
    // 原本是用to.path来判断的，但是这对于query里有参数的列表不好判断..
    // @ts-ignore
    const needPermission = _.chain(permissions).find({path: to.fullPath}).get('number', 'unkown').value();
    if (needPermission !== 'unkown' && _.findIndex(current_permissions, {number: needPermission}) == -1) {
        next({path: '/no_permit_warning'})
    } else {
        next();
    }

}
router.beforeEach((to, from, next) => {
    const ignoredRoute = ['login', 'unionLogin'];
    if (ignoredRoute.indexOf(<string>to.name) > -1) {
        next();
        return;
    }
    const accessToken = util.cookies.get('token');
    if (!_.isEmpty(accessToken)) {

        axios.get(`/api/validate-token/${accessToken}`).then((resp) => {
            // 下面做一些登录授权后的全局数据的初始化

            // @ts-ignore
            if (store.state.vendors.loadAllTimestamp === null) {

                store.dispatch('vendors/loadAll');
                store.dispatch('vendors/loadTrade');
                //

                //如果不经过登录，直接到主页。人物的信息是缺失的

                //
                // getMenuList(_.get(store.state, 'd2admin.user.info.roleNum', -1)).then(list => {
                //   store.commit('d2admin/menu/asideSet', list)
                // });

                permissions.push(..._.clone(require('./custommenu').allList));
                getMenuList(_.get(store.state, 'd2admin.user.info.roleNum', -1)).then(res => {
                  console.log('load menu list');
                    store.commit('d2admin/menu/asideSet', res.menuList);
                    // 操作权限
                    store.commit('vendors/setOperateList', res.operatePermitList);

                    // 赋值当前列表
                    current_permissions.push(...res.permitList);

                    checkPermitPass(to,next);
                });
            }else{
                checkPermitPass(to,next);
            }

        }).catch((e) => {
            console.log('err :',e);
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            })
        })
    } else {
        next({
            path: '/login',
            query: {redirect: to.fullPath}
        })
    }
});

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach(async (to, from, next) => {
    // 确认已经加载多标签页数据 https://github.com/d2-projects/d2-admin/issues/201
    await store.dispatch('d2admin/page/isLoaded')
    // 确认已经加载组件尺寸设置 https://github.com/d2-projects/d2-admin/issues/198
    await store.dispatch('d2admin/size/isLoaded')
    // 进度条
    NProgress.start()
    // 关闭搜索面板
    store.commit('d2admin/search/set', false)
    // 验证当前路由所有的匹配中是否需要有登录验证的
    if (to.matched.some(r => r.meta.auth)) {
        // 这里暂时将cookie里是否存有token作为验证是否登录的条件
        // 请根据自身业务需要修改
        const token = util.cookies.get('token')
        if (token && token !== 'undefined') {
            next()
        } else {
            // 没有登录的时候跳转到登录界面
            // 携带上登陆成功之后需要跳转的页面完整路径
            next({
                name: 'login',
                query: {
                    redirect: to.fullPath
                }
            })
            // https://github.com/d2-projects/d2-admin/issues/138
            NProgress.done()
        }
    } else {
        // 不需要身份校验 直接通过
        next()
    }
})

router.afterEach(to => {
    // 进度条
    NProgress.done()
    // 多页控制 打开新的页面
    store.dispatch('d2admin/page/open', to)
    // 更改标题
    util.title(to.meta.title)
})

export default router;
